@use '@/scss/underscore' as _;

.reachLogto {
  width: 100%;
  padding: _.unit(3) _.unit(4);
  border: 1px solid var(--color-divider);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .reachLogtoInfo {
    display: flex;
    align-items: center;

    .reachLogtoIcon {
      width: 36px;
      height: 36px;
      margin-right: _.unit(4);
      flex-shrink: 0;
    }

    .reachLogtoTitle {
      font: var(--font-title-3);
    }

    .reachLogtoDescription {
      font: var(--font-body-2);
      color: var(--color-text-secondary);
      padding-right: _.unit(4);
    }
  }
}
